<script>
import format from 'date-fns/format'

export default {
    props: {
        options: {type:Object},
        group: {type:Number|String},
        day: {type:String},
    },
    data() {
        return {
            dateFormat: 'YYYY-MM-DD',
            group_: null,
            day_: null
        }
    },
    methods: {
        formatDates(date) {
            let formattedDate = ''
            if (date) {
                formattedDate = format(date, this.dateFormat)
            }
            return formattedDate
        },
        goto() {
            if(this.day_ && this.group_) {
                var id = 'all'
                if(!isNaN(parseInt(this.group_)) && isFinite(this.group_) ) {
                    id = this.group_
                }
                if(id == 0 ) id = 'all'
                window.location.href = '/group/'+id+'/nippou/?day='+this.day_
            }
        }
    },
    created() {
        this.group_ = this.group
        this.day_ = this.day
    }
}
</script>